import Vue from 'vue';
import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { PremiumPurchaseInfo } from 'frontend/types/premium';

const premiumPurchaseInfo: Module<PremiumPurchaseInfo, RootState> = {
  namespaced: true,
  state: {} as PremiumPurchaseInfo,
  mutations: {
    setValue(state: PremiumPurchaseInfo, value: PremiumPurchaseInfo): void {
      Object.assign(state, value);
    },
  },
};

export default premiumPurchaseInfo;
